export enum TipoAssinanteEnum {
    "Colaborador BNDES" = 1,
    "Pessoa física externa" = 2
}